export default "__VITE_ASSET__CCd2KvRW__"